define('app/editor/dialogs/SaveDialogView',['require','glu/itemView','config','hbs!./SaveDialogView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		config = require('config');

	var view = ItemView.extend({

		template: require('hbs!./SaveDialogView.hbs'),
		nameFieldId: '#save-dialog-name',
		descriptionFieldId: '#save-dialog-description',

		getClass: function() {
			return 'modal-save';
		},

		dialogTitle: 'Save',

		dialogButtons: [{
			text: 'Save',
			callback: 'save',
			className: 'btn-primary'
		}],

		events: {
			'change #save-dialog-name': 'onChangeName',
			'keyup #save-dialog-name': 'onChangeName',
			'change #save-dialog-description': 'onChangeDesc',
			'keyup #save-dialog-description': 'onChangeDesc'
		},

		validate: function(val, field) {
			var myRegEx = config.textRegex;
			var isValid = myRegEx.test(val);
			if (isValid) {
				this.$el.find(field).parent().removeClass('has-error');
				this.$el.find(field).parent().find('span.help-block').text('');
			} else {
				this.$el.find(field).parent().addClass('has-error');
				this.$el.find(field).parent().find('span.help-block').text('Unsupported characters');
			}
		},

		onChangeName: function() {
			var name = this.uigetName();
			if (name.trim() === '') {
				this.$el.find(this.nameFieldId).parent().addClass('has-error');
			} else {
				this.validate(name, this.nameFieldId);
			}
		},

		onChangeDesc: function() {
			var description = this.uigetDescription();
			if (description.trim() !== '') {
				this.validate(description, this.descriptionFieldId);
			} else {
				this.$el.find(this.descriptionFieldId).parent().removeClass('has-error');
			}
		},

		uigetName: function() {
			return this.$el.find(this.nameFieldId).val();
		},

		uisetName: function(name) {
			return this.$el.find(this.nameFieldId).val(name);
		},

		uigetDescription: function() {
			return this.$el.find(this.descriptionFieldId).val();
		},

		uisetDescription: function(description) {
			return this.$el.find(this.descriptionFieldId).val(description);
		},

		isValid: function() {
			this.onChangeName();
			this.onChangeDesc();
			return (!this.$el.find(this.nameFieldId).parent().hasClass('has-error') &&
				!this.$el.find(this.descriptionFieldId).parent().hasClass('has-error'));
		},

		isOwner: function() {
			return this.model.isOwner();
		},

		serializeData: function() {
			return this;
		}

	});

	return view;
});

